import { styled, TextField } from '@mui/material'

export const DefinitionField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: theme.typography.pxToRem(13),
    lineHeight: 1.5,
    whiteSpace: 'pre',
    overflowX: 'auto',
  },
}))
